export const changeBodyBackgroundColor = (color) => {
  document.body.style.backgroundColor = color;
};
